import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, SitterNotificationSettings } from '../types';

const URL = '/v2/sitter-notification-settings';

class SitterNotificationSettingsService {
  static getById(id: number): Promise<DataResponse<SitterNotificationSettings>> {
    const config = {
      params: {
        id,
      },
    };

    return axios.get(`${URL}/${id}`, config);
  }

  static delete(id: number, config?: AxiosRequestConfig): Promise<unknown> {
    return axios.delete(`${URL}/${id}`, config);
  }

  static patch(id: number, data: unknown, config?: AxiosRequestConfig): Promise<DataResponse<SitterNotificationSettings>> {
    return axios.patch(`${URL}/${id}`, data, config);
  }
}

export { SitterNotificationSettingsService };
